<template>
  <vs-card class="pl-5 pt-5 pr-1 m-0">
    <div>
      <a href="#" @click="$emit('changeTab','ComponentRevenue')">
        <h4 class="title-report font-semibold">Revenue Report</h4>
      </a>
      <p class="text-base font-medium">Summary of unbilled, billed, and collected amounts.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentOriginatingSolicitorRevenue')">
        <h4 class="title-report font-semibold">Tax Report</h4>
      </a>
      <p class="text-base font-medium">Summary of Tax.<a href="#"></a></p>
    </div>
<!--    <div>-->
<!--      <a href="#"  @click="$emit('changeTab','ComponentFeeAllocation')">-->
<!--        <h4 class="title-report font-semibold">Fee Allocation Report</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium">Summary of invoiced service and expense allocations.<a href="#"></a></p>-->
<!--    </div>-->
  </vs-card>
</template>

<script>
export default {
  name: "RevenueReport"
}
</script>

<style scoped>

</style>
